import { createAsyncThunk } from "@reduxjs/toolkit";

import { restoreBackupByActivityRequest } from "Api/activity/restoreBackupByActivity.request";
import logger from "Libs/logger";
import { AsyncThunkOptionType } from "Reducers/types";

import type { Activity } from "Api/activity/types";
import type { RestoreBackupByActivity } from "../types";

export const restoreBackupByActivity = createAsyncThunk<
  Activity[],
  RestoreBackupByActivity,
  AsyncThunkOptionType
>(
  "app/activity/project/restore",
  async (
    { organizationDescriptionId, projectDescriptionId, activityId },
    { rejectWithValue }
  ) => {
    try {
      const activityResponse = await restoreBackupByActivityRequest({
        projectId: projectDescriptionId,
        activityId: activityId
      });

      return activityResponse?._embedded.activities;
    } catch (err) {
      if (![404, 403].includes((err as { code: number }).code)) {
        logger(err, {
          action: "app/activity/project/restore",
          meta: {
            organizationDescriptionId,
            projectDescriptionId,
            activityId
          }
        });
      }

      return rejectWithValue(err);
    }
  }
);
